import { render, staticRenderFns } from "./Trashbin.vue?vue&type=template&id=489737c6&scoped=true&"
import script from "./Trashbin.vue?vue&type=script&lang=js&"
export * from "./Trashbin.vue?vue&type=script&lang=js&"
import style0 from "./Trashbin.vue?vue&type=style&index=0&id=489737c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489737c6",
  null
  
)

export default component.exports